<template>
  <b-col>
    <base-button
      type="default"
      block
      class="mb-3"
      @click="abrirEditorProgenitor()"
    >
      {{ tipoFormulario == 2 ? "Crear nuevo Padre" : "Crear nueva Madre" }}
    </base-button>
    <model-padres
      :progenitor="progenitor"
      :tipoFormulario="tipoFormulario"
      idModal="modal-padres"
      @datosProgenitor="editarDatosProgenitor"
    />
    <tabla-padres
      :data="
        tipoFormulario == 2
          ? listaPadres
          : tipoFormulario == 3
          ? listaMadres
          : -1
      "
      :tipoProgenitor="tipoFormulario"
      @editarPadre="abrirEditorProgenitor"
      @eliminarPadre="eliminarPadre"
    />
  </b-col>
</template>
<script>
import axios from "@/directives/axios.js";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import TablaPadres from "@/components/Tables/TablaPadres";
import ModelPadres from "@/components/modals/ModalPadres.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: {
    VueBootstrapTypeahead,
    TablaPadres,
    ModelPadres,
  },
  props: { tipoFormulario: { type: Number, default: -1 } },
  data() {
    return {
      progenitor: {
        id: undefined,
        nombre: undefined,
        apellido1: undefined,
        apellido2: undefined,
        fecha_nacimiento: undefined,
        telefono: undefined,
        profesion: undefined,
      },
    };
  },
  computed:{
    listaMadres() {
      if (this.$store.getters.getTodasMadresHijos != undefined) {
        if (this.$store.getters.getTodasMadresHijos.length > 0) {
          loader.close();
          return this.$store.getters.getTodasMadresHijos;
        } else {
          loader.close();
          return [];
        }
      } else {
        loader.open();
        this.$store.dispatch("recargaMadres");
        return [];
      }
    },
    listaPadres() {
      if (this.$store.getters.getTodosPadresHijos != undefined) {
        if (this.$store.getters.getTodosPadresHijos.length > 0) {
          loader.close();
          return this.$store.getters.getTodosPadresHijos;
        } else {
          loader.close();
          return [];
        }
      } else {
        loader.open();
        this.$store.dispatch("recargaPadres");
        return [];
      }
    },
  },
  methods: {
    eliminarPadre(id) {
      switch (this.tipoFormulario) {
        case 2:
        loader.open();
          axios({
            method: "delete",
            url: `/padres/eliminarPadre?id=${id}`,
            withCredentials: true,
          })
            .then((data) => {
              this.$store.dispatch("recargaPadres", data);
              loader.close();
              swal
                .fire({
                  title: `Padre eliminado Correctamente`,
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-success",
                  icon: "success",
                })
                .then(() => {
                  
                });
            })
            .catch(() => {
              loader.close();
              swal.fire({
                title: `Error`,
                text: "Ocurrio un error inesperado, intentelo mas tarde",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-warning",
                icon: "warning",
              });
            });
          break;
        case 3:
        loader.open();
          axios({
            method: "delete",
            url: `/padres/eliminarMadre?id=${id}`,
            withCredentials: true,
          })
            .then((data) => {
              this.$store.dispatch("recargaMadres", data);
              loader.close();
              swal
                .fire({
                  title: `Madre eliminada Correctamente`,
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-success",
                  icon: "success",
                });
            })
            .catch(() => {
              loader.close();
              swal.fire({
                title: `Error`,
                text: "Ocurrio un error inesperado, intentelo mas tarde",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-warning",
                icon: "warning",
              });
            });
          break;

        default:
          break;
      }
    },
    abrirEditorProgenitor(id) {
      if (this.tipoFormulario == 2 && id) {
        this.progenitor = this.listaPadres.find((element => element.id == id));
      } else if (this.tipoFormulario == 3 && id) {
        this.progenitor = this.listaMadres.find((element => element.id == id));
      } else {
        this.progenitor = [];
      }
      this.$nextTick(() => {
        this.$bvModal.show("modal-padres");
      });
    },
    editarDatosProgenitor(data) {
      switch (this.tipoFormulario) {
        case 2:
          this.editarPadre(data);
          break;
        case 3:
          this.editarMadre(data);
          break;

        default:
          break;
      }
    },
    editarPadre(data) {
      loader.open();
      axios({
        method: "post",
        url: `/padres/crearPadre`,
        withCredentials: true,
        data: data,
      })
        .then((data) => {
          this.$store.dispatch("recargaPadres", data);
          this.$bvModal.hide("modal-padres");
          loader.close();
          swal
            .fire({
              title: `Datos guardado Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then(() => {
              this.resetProgenitor();
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un error inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    editarMadre(data) {
      loader.open();
      axios({
        method: "post",
        url: `/padres/crearMadre`,
        withCredentials: true,
        data: data,
      })
        .then((data) => {
          this.$bvModal.hide("modal-padres");
          this.$store.dispatch("recargaMadres", data);
          loader.close();
          swal
            .fire({
              title: `Datos guardado Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then(() => {
              this.resetProgenitor();
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un error inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    resetProgenitor() {
      this.progenitor.id = undefined;
      this.progenitor.nombre = undefined;
      this.progenitor.apellido1 = undefined;
      this.progenitor.apellido2 = undefined;
      this.progenitor.fecha_nacimiento = undefined;
      this.progenitor.telefono = undefined;
      this.progenitor.profesion = undefined;
    },
  },
  mounted() {  },
};
</script>
<style></style>
